exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-media-preview{width:100%;height:100%}.table-media-preview__audio{padding:32px 0 12px 0;text-align:center}.table-media-preview__audio .audio-player{margin-right:12px}.table-media-preview__audio i.k-icon-file-audio{font-size:128px;color:#e7e9ee}.table-media-preview__image{width:100%;height:100%}.table-media-preview__text{padding:32px}.table-media-preview__video{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}@media screen and (min-width: 600px){.table-media-preview{min-width:400px}}", ""]);

// exports
